<template>
  <div class="blocks"
    :style="{ 'border-bottom-color': this.bottom_color ? this.bottom_color : '' }">
    <!-- PartList.vue -->
    <div class="row">
      <div class="col-12 title"
        :style="{ 'color': this.header_color }">
        <!-- <i class="sprite" v-bind:src="icon"></i> -->
        <img v-bind:src="icon" />
        <div v-text="title"></div>
      </div>
    </div>
    <div class="row info">
      <div class="col-12" v-if="false">
        <ul class="decimal">
          <li v-for="(item, itemIndex) in course" :key="itemIndex" v-text="item"></li>
        </ul>
      </div>
      <div class="col-12 weekly"
        :class="{
          'topic': is_topic == true
        }"
        :style="{ 'color': getColorValue('weeks_header', 'text', 0) }">
        <div class="row no-gutters text-center row-header weeks_column-static"
          v-if="has_weeks_columns_4 == false">
          <div class="col-3 col-lg-1">週次</div>
          <div class="col text-left subject">單元主題</div>
          <!-- <div class="col-3">教學元件</div>
          <div class="col-3">教學活動應用</div> -->
        </div>
        <div class="row no-gutters text-center row-header weeks_column-dynamic"
          v-if="has_weeks_columns_4 == true">
          <div class="col-3 col-lg-1"
            v-text="weeks_columns_4[0]"></div>
          <div class="col text-left subject" v-text="weeks_columns_4[1]"></div>
        </div>
        <div class="row no-gutters weekly-item"
          v-for="(week, weekIndex) in weeks" :key="week.id"
          v-init="isOddItem = weekIndex % 2 == 1"
          :style="{ 'border-top-color': getColorValue('weeks.normal', '', weekIndex) }">
          <div class="row no-gutters row-space-on-week-item"
            v-if="is_topic"
            :style="{ 'background-color': getColorValue('weeks.normal', '', weekIndex) }"
            ><div class="text-large"
              :class="{
                'col': is_topic == false,
                'col-topic': is_topic == true
              }"
              :style="{
                'color': getColorValue('weeks_no', 'text', weekIndex),
                'background-color': getColorValue('weeks.normal', '', weekIndex) }">
                <span v-html="week.topic"></span>
              </div>
          </div>
          <!-- week-no -->
          <div class="col-3 col-lg-1 item-no week-no"
            :class="{
              'justify-content-center': getIsMobile
            }"
            :style="{
              'color': getColorValue('weeks_no', 'text', weekIndex),
              'background-color': getColorValue('weeks.normal', '', weekIndex)
            }">
            <div class="week_no text-large text-center" v-text="week.no"></div>
          </div>
          <div class="col-9 col-lg-11">
            <!-- parts container in desktop -->
            <b-container class="week_container"
              v-for="(subject, subjectIndex) in getSubjects(week)" :key="(weekIndex * 1000) + subjectIndex"
              :class="`week-${weekIndex}`">
              <div class="header_container">
                <b-row class="header">
                  <div class="col"
                    v-html="subject.subject"
                    :class="{ 'text-large': is_topic, 'topic-subject': is_topic }"
                    :style="{ 'color': getColorValue('weeks.text', '#000', weekIndex) }"></div>
                </b-row>
                <b-row class="header"
                  v-if="getIsMobile == false && has_weeks_columns_4 == false && getPartsCount(subject) > 0 && is_topic == false"
                  :style="{
                    'border-bottom': `2px solid ${getColorValue('weeks.normal', '', weekIndex)}`,
                    'color': getColorValue('weeks.normal', '', weekIndex),
                  }">
                  <b-col class="col-5">教學元件</b-col>
                  <b-col>教學活動應用</b-col>
                </b-row>

                <b-row class="header"
                  v-if="getIsMobile == false && has_weeks_columns_4 == true && getPartsCount(subject) > 0 && is_topic == false"
                  :style="{
                    'border-bottom': `2px solid ${getColorValue('weeks.normal', '', weekIndex)}`,
                    'color': getColorValue('weeks.normal', '', weekIndex),
                  }">
                  <b-col class="col-5" v-text="weeks_columns_4 ? weeks_columns_4[2] : ''"></b-col>
                  <b-col v-text="weeks_columns_4 ? weeks_columns_4[3] : ''"></b-col>
                </b-row>

              </div>
              <!-- parts container -->
              <div class="parts desktop"
                v-if="getIsMobile == false && getPartsCount(subject) > 0">
                <div class="parts-container">
                  <b-row class="part no-gutters"
                    v-for="(part, partIndex) in (subject['parts'] || [])" :key="(weekIndex * 100000) + (subjectIndex * 1000) + part.id"
                    v-init="_applications = getMappedApplications(part.application_id, true, part)"
                    @mouseover="PartHover(part, weekIndex, subjectIndex, partIndex, part.id)"
                    @mouseleave="PartLeave()"
                    :class="{ 'hover': subjectIndex == currentSubjectIndex && partIndex == currentPartIndex && part.id == currentPartId }"
                    :style="{
                      'color': getColorValue('weeks.text_part', 'weeks.text', weekIndex),
                      'border-left-color': getColorValue('weeks.normal', '', weekIndex),
                      'display': getAttribute(part, 'display'),
                      }">
                    <b-col class="col-5 part-name"
                      :class="`part-${weekIndex}-${partIndex}`">
                      <div class="icon-container" v-if="getAttribute(part, 'part_type') != '' || true">
                        <img class="icon hide-on-hover"
                          v-if="getAttribute(part, 'src') != ''"
                          :src="isOddItem == false ? play_icons.i_01 : play_icons.i_02" />
                        <img class="icon show-on-hover"
                          v-if="getAttribute(part, 'src') != ''"
                          :src=play_icons.over />
                      <!-- <img class="icon"
                        :src="isOddItem == false ? play_icons.i_01 : play_icons.i_02"
                        @mouseover="ChangeImage($event, play_icons.over)" /> -->
                      </div>
                      <div
                        v-if="!(currentWeekIndex == weekIndex && currentSubjectIndex == subjectIndex && currentPartIndex == partIndex)"
                        v-html="parseTitle(part.title)"
                        @click="ShowPart(part, partIndex)"
                        :class="{ 'item': getAttribute(part, 'part_type') != '' || true }"
                        :style="{
                          'color': getHoverTextColor(weekIndex, subjectIndex, partIndex, getColorValue('weeks.normal', '', weekIndex))
                          }"></div>
                      <div class="item hover x2"
                        v-if="(currentWeekIndex == weekIndex && currentSubjectIndex == subjectIndex && currentPartIndex == partIndex)"
                        v-html="parseTitle(part.title)"
                        @click="ShowPart(part, partIndex)"
                        :class="{ 'disabled': getAttribute(part, 'src') == '' }"
                        :style="{
                          'color': ((current_course.title.indexOf('產業分析與創新創業') > -1) || (current_course.title.indexOf('基礎日語視聽訓練') > -1)) ? getColorValue('section.header', '', weekIndex) : '#f75d81'
                          }"></div>
                    </b-col>
                    <!-- applications or description -->
                    <!-- applications -->
                    <b-col
                      align-self="center"
                      v-if="_applications.length > 0 && checkIsNeedToShow(subject.parts, partIndex, getForceVisible)"
                      :style="{
                        'border-left-color': getColorValue('weeks.normal', '', weekIndex)
                        }">
                        <div class="parts-container"
                          :class="part['application_css_class']"
                          v-for="(application_title, appIndex) in _applications" :key="appIndex">
                          <div class="icon-container" v-if="getAttribute(part, 'part_type') != '' && getAttribute(part, 'src') != ''">
                            <img class="icon icon-description"
                                v-bind:src="isOddItem == false ? read_icons.i_01 : read_icons.i_02"
                                v-if="true || checkIsNeedToShow(week['parts'], partIndex, getForceVisible)">
                          </div>
                          <div class="part description"
                            v-html="application_title == '' ? '&nbsp;' : application_title"></div>
                        </div>
                    </b-col>
                    <!-- or description -->
                    <b-col
                      align-self="center"
                      v-if="part['description'] !== undefined"
                      :style="{
                          'border-left-color': getColorValue('weeks.normal', '', weekIndex)
                          }">
                      <div class="icon-container" v-if="getAttribute(part, 'part_type') != '' && getAttribute(part, 'src') != ''">
                        <img class="icon icon-description"
                            v-bind:src="isOddItem == false ? read_icons.i_01 : read_icons.i_02"
                            v-if="getForceVisible == false && (true || checkIsNeedToShow(week['parts'], partIndex, getForceVisible))">
                      </div>
                      <div class="part description" v-html="part.description"></div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-container>
          </div>
          <div class="col-12 hide-not-mobile weekly-item"
            v-if="getIsMobile == true">
            <b-container fluid>
              <b-row class="header header-static"
                v-if="has_weeks_columns_4 == false && getPartsCount(subject) > 0"
                :style="{
                  'border-bottom': `2px solid ${getColorValue('weeks.normal', '', weekIndex)}`,
                  'color': getColorValue('weeks.normal', '', weekIndex),
                }">
                <b-col class="col">教學元件</b-col>
              </b-row>
              <b-row class="header header-define"
                v-if="has_weeks_columns_4 == true && getPartsCount(week) > 0"
                :style="{
                  'border-bottom': `2px solid ${getColorValue('weeks.normal', '', weekIndex)}`,
                  'color': getColorValue('weeks.normal', '', weekIndex),
                }">
                <b-col class="col" v-text="weeks_columns_4 ? weeks_columns_4[2] : ''"></b-col>
              </b-row>
              <b-row class="parts hide-not-mobile"
                v-if="getPartsCount(week) > 0">
                <b-col cols="12" class="parts-col">
                  <div class="parts-container">
                    <b-row class="part no-gutters"
                      v-for="(part, partIndex) in (week['parts'] || [])" :key="partIndex"
                      v-init="_applications = getMappedApplications(part.application_id, true, part)"
                      :style="{
                        'color': getColorValue('weeks.text_part', 'weeks.text', weekIndex),
                        'border-left-color': getColorValue('weeks.normal', '', weekIndex),
                        'display': getAttribute(part, 'display'),
                        }">
                        <b-col class="col-11 part-name"
                          :class="`part-${weekIndex}-${partIndex}`">
                          <div class="icon-container">
                            <img class="icon hide-on-hover"
                              :src="isOddItem == false ? play_icons.i_01 : play_icons.i_02" />
                            <img class="icon show-on-hover"
                              :src=play_icons.over />
                          </div>
                          <div class="item"
                            v-if="!(currentWeekIndex == weekIndex && currentSubjectIndex == subjectIndex && currentPartIndex == partIndex)"
                            v-text="part.title"
                            @click="ShowPart(part, partIndex)"
                            :style="{
                              'color': getHoverTextColor(weekIndex, subjectIndex, partIndex, getColorValue('weeks.normal', '', weekIndex))
                              }"></div>
                          <div class="item hover x4"
                            v-if="(currentWeekIndex == weekIndex && currentSubjectIndex == subjectIndex && currentPartIndex == partIndex)"
                            v-text="part.title"
                            @click="ShowPart(part, partIndex)"
                            :class="{ 'disabled': getAttribute(part, 'src') == '' }"
                            :style="{
                              'color': '#f75d81'
                              }"></div>
                        </b-col>
                        <b-col class="col-1">
                          <!-- applications -->
                          <div class="icon-container"
                            v-if="_applications.length > 0">
                            <img class="icon has-tooltip"
                              v-for="(app, appIndex) in _applications" :key="app"
                              v-tooltip="part.description"
                              v-b-popover.hover.html.left="app"
                              :src="isOddItem == false ? read_icons.i_01 : read_icons.i_02" />
                          </div>
                          <!-- description -->
                          <div class="icon-container"
                            v-if="getAttribute(part, 'description') != ''">
                            <img class="icon has-tooltip"
                              zv-tooltip="part.description"
                              v-b-popover.hover.html.left="part.description"
                              :src="isOddItem == false ? read_icons.i_01 : read_icons.i_02" />
                            <!-- <img class="icon show-on-hover"
                              v-tooltip="part.description"
                              :src=play_icons.over /> -->
                          </div>
                        </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </div>
    </div>
    <video-js ref="video"></video-js>
    <photo-viewer ref="photo"></photo-viewer>
  </div>
</template>
<script>
  import {
    mapGetters, mapActions, mapState,
  } from 'vuex'
  import $ from 'jquery'
  import { globalMixin, platformMixin, courseMixin } from './_Mixins'

  import _ from 'lodash'
  import VideoJS from '@/components/VideoJS'
  import PhotoViewer from '@/components/PhotoViewer'

  import utils from '../utils'

  export default {
    data () {
      return {
        // course will pass from CourseIntroduce.vue
        //course: null,
        currentWeekIndex: -1,
        currentSubjectIndex: -1,
        currentPartIndex: -1,
        currentPartId: -1,
      }
    },

    props: [
      'current_course',
      'prefix',
      'title',
      'icon',
      'header_color',
      'bottom_color',
      // 'play_icons',
      // 'read_icons',
      'item_type',
      'assets_path' ],

    mounted() {

    },

    mixins: [ globalMixin, platformMixin, courseMixin ],

    components: {
      'video-js': VideoJS,
      'photo-viewer': PhotoViewer,
    },

    methods: {
      updateCourse(course) {
        console.log('PartList.vue',
          '#323 updateCourse',
          'course',
          course)
      },

      openUrl(url) {
        window.open(url, `_blank_${url}`)
      },

      showPhoto(src) {
        this.$refs.photo.open(src)
      },

      playVideo(src, srcTextTrack) {
        //console.log('SeriesList.vue', 'play video', this.$emit)
        let _this = this
        // let videojs_player = videojs('video')

        //console.log('SeriesList.vue', 'play video', 'srcTextTrack', srcTextTrack)
        //console.log('SeriesList.vue', 'play video', 'videojs_player.addRemoteTextTrack', videojs_player.addRemoteTextTrack)
        let subtitleOptions = null

        if (utils.hasValue(srcTextTrack)) {
          var createOption = function(subtitleSrc, isDefault = true) {
            return {
              "kind": "subtitles",
              "label": "Chinese",
              "language": 'zh',
              "srclang": "zh",
              "src": subtitleSrc,
              "mode": 'showing',
              "default": isDefault,
              // "html5": {
              //     nativeTextTracks: false
              // },
            }
          }

          let hasSubtitleExtension =
            srcTextTrack.endsWith('.srt') ||
            srcTextTrack.endsWith('.vtt')

          if (hasSubtitleExtension == false) {
            // has no extension defined
            // subtitleOptions = []
            // subtitleOptions.push(createOption(`${srcTextTrack}.vtt`, false))
            // subtitleOptions.push(createOption(`${srcTextTrack}.srt`, true))
            subtitleOptions = createOption(`${srcTextTrack}.vtt`)
          }
          else {
            subtitleOptions = createOption(srcTextTrack)
          }
        }

        // videojs_player.ready(function() {

        // })
        // console.log('SeriesList.vue', 'play video', '>>> subtitleOptions', subtitleOptions)

        //videojs_player.addRemoteTextTrack(subtitleOption, true)

        //console.log('SeriesList.vue', 'play video', '>>> remoteTextTracks().length', videojs_player.remoteTextTracks().length)

        //_this.$refs.video.setPlayerOptions = this.playerOptions
        let playerOptions = {
          // videojs options
          controls: true,
          language: 'zh-TW',
          sources: [],
        }

        _this.$refs.video.play(src, playerOptions, subtitleOptions)
        // console.log(this.$refs)
      },

      parseTitle(title) {
        var find = /<br \/>/
        var replaceString = "&nbsp;"
        var replaceStrings = replaceString.repeat(9) // replace n times of string defined
        title = title.replace(find, '<br />' + replaceStrings)

        return title
      },

      getSubjects(week) {
        // console.log('PartList.vue > getSubjects : week : ', week)

        let subjects = []
        if (week.hasOwnProperty("subjects")) {
          subjects = week['subjects']
        }

        if (week.hasOwnProperty("subject")) {
          subjects.push(week)
        }

        // console.log('PartList.vue > getSubjects : subjects :', subjects)

        return subjects
      },

      async ShowPart(part) {
        // if (!this.current_course || this.current_course == undefined) return

        if (!part || part == undefined) return

        // debugger
        if (part['part_type'] && part['src']) {

          let type = part['part_type'].toLowerCase()
          let src = part['src']
          let srcTextTrack = part['src_text_track']
          let need_prefix = part['need_prefix'] == undefined ? true : part['need_prefix'] == true;

          //if (src.startsWith('http') == false && src.startsWith('//')) {
          // if (type == 'url') {
          //   let prefix = this.current_course_prefix
          //   src = `http://media-dlc.scenet.net/videos/${prefix}${src}`
          // }
          // else {
          //   //src = `http://media-dlc.sce.pccu.edu.tw/deep/${prefix}/${src}`
          //   src = `http://media-dlc.scenet.net/videos/${previx}${src}`
          // }

        //   console.log('PartList.vue',
        //     isAlreadyUrl,
        //     src)

          // console.log('CourseIntroduceBlock.vue', isAlreadyUrl)
          if (utils.isAlreadyUrl(src) == false) {
            src = await this.combineFullResourceUrl(src, need_prefix)
          }

          if (utils.hasValue(srcTextTrack) == false) {
            let lastIndex = src.lastIndexOf('/')
            let url = src
            let filename = src

            if (lastIndex > 0) {
              filename = src.substr(lastIndex + 1)
              url = src.substr(0, lastIndex)
            }

            //console.log('PartList.vue', 'filename', filename, 'url', url)

            lastIndex = filename.lastIndexOf('.')
            let filenameWithoutExtension = filename.substr(0, lastIndex)
            srcTextTrack = `${url}/${filenameWithoutExtension}`

            // console.log('PartList.vue', 'srcTextTrack', srcTextTrack)
          }

          if (utils.hasValue(srcTextTrack) && utils.isAlreadyUrl(srcTextTrack) == false) {
            srcTextTrack = await this.combineFullResourceUrl(srcTextTrack, need_prefix)
          }

          // console.log('PartList.vue',
          //   isAlreadyUrl,
          //   src)

          // console.log(this)
          // console.log(isAlreadyUrl)
          // console.log(type)
          // console.log(src)
          // return
          // debugger

          let _this = this

          var processSrc = function (type, src) {
            if (type == 'url') {
              _this.openUrl(src)
              return
            }

            if (type == 'video') {
              _this.playVideo(src, srcTextTrack)
              return
            }

            if (type == 'photo') {
              _this.showPhoto(src)
              return
            }
          }

          if (utils.isPromise(src)) {
            // debugger
            src.then(function(_src) {
              if (utils.hasValue(srcTextTrack)) {
                if (utils.isPromise(srcTextTrack)) {
                  srcTextTrack.then(function(_srcTextTrack) {
                    processSrc(type, _src, _srcTextTrack)
                  })
                }
                else {
                  processSrc(type, _src, srcTextTrack)
                }
              }
              else {
                processSrc(type, src)
              }
            })
          }
          else {
            // debugger
            processSrc(type, src, srcTextTrack)
          }

        }

        return
      },

      getColorValue(key, defaultValue, index) {
        let testIsKey = (value) => {
          if (value.startsWith('#'))
            return value
          else if (value == '')
            return ''

          return this.getColorValue(value, '', index)
        }
        if (!this.colors) {
          return testIsKey(defaultValue)
        }

        let isNumber = Number.isInteger(index)

        if (index !== undefined && isNumber == false) return testIsKey(defaultValue)

        if (typeof(key) == 'object') {
          let _result = eval(key.test)
          if (key[_result]) {
            key = key[_result]
          }
          else {
            key = 'text'
          }
          //debugger
        }

        let keys = key.split('.')
        var currentItem = this.colors;
        for (var i = 0; i < keys.length; i++) {
          if (!currentItem) break;

          key = keys[i]

          // if (key == 'main') debugger

          if (!currentItem[key]) {
            return testIsKey(defaultValue)
          }

          currentItem = currentItem[key]
          if (Array.isArray(currentItem)) {
            currentItem = currentItem[index % 2]
          }

          if (i == keys.length - 1) {

            if (!currentItem) {
              return testIsKey(defaultValue)
            }

            return currentItem
          }
        }

        return testIsKey(defaultValue)
      },

      PartHover(part, weekIndex, subjectIndex, partIndex, partId) {
        // console.log('** PartList.vue > PartHover : dump : ', weekIndex, subjectIndex, partIndex, partId)
        if (this.getAttribute(part, 'part_type') == '') return

        if (weekIndex > -1) this.currentWeekIndex = weekIndex
        if (subjectIndex > -1) this.currentSubjectIndex = subjectIndex
        if (partIndex > -1) this.currentPartIndex = partIndex
        if (partId > -1) this.currentPartId = partId
      },

      PartLeave() {
        this.currentWeekIndex = -1
        this.currentSubjectIndex = -1
        this.currentPartIndex = -1
        this.currentPartId = -1
      },

      resetAllPartTextColor() {
        $('parts-container')
      },

      getHoverTextColor(hoverWeekIndex, hoverSubjectIndex, hoverPartIndex, color_hover) {
        //return
        if (this.currentWeekIndex != hoverWeekIndex ||
          this.currentSubjectIndex != hoverSubjectIndex ||
          this.currentPartIndex != hoverPartIndex) {

            return
          }

        let selector = `.part-${hoverWeekIndex}-${hoverPartIndex}`;

        let target = $(selector)

        // $('.parts-container .part-name').each((index, part) => {
        //   $part = $(part)

        //   if ($part.data('origin-text-color')) {
        //     $part.css('color', $part.data('origin-text-color'))
        //   }
        // })

        if (target.length > 0) {
          let origin_color = $(target[0]).css('color')

          $(target[0]).data('origin-text-color', origin_color)

          $(target[0]).css('color', color_hover)
        }
      },

      ChangeImage($event, new_icon, disabled = false) {
        if (disabled) return

        //let $target = $event.target.querySelector('.icon')
        //let $target = $($event.target).find('.icon')
        let $target = $event.target

        if (!$target || $target.length == 0) return

        $target.original_src = $target.src
        $target.src = new_icon
      },

      ChangeBackImage($event, disabled = false) {
        if (disabled) return

        // let $target = $event.target.querySelector('.icon')
        // if (!$target) return
        let $target = $event.target

        if ($target['original_src']) {
          $target.src = $target.original_src
        }

        this.currentPartIndex = -1
      },

      checkIsNeedToShow(parts, partIndex, forceVisible = false) {

        if (forceVisible == true) return true

        if (!parts) return false

        if (partIndex == 0) return true

        if (parts[partIndex - 1].application_id != parts[partIndex].application_id) {
          return true
        }

        // current application same as previous part
        return false
      },

      getPartsCount(week) {
        // console.log('getPartsCount', week)

        if (!week) return 0
        if (!week['parts']) return 0
        if (Array.isArray(week['parts']) == false) return 0

        return week['parts'].length
        // resolve(week['parts'].length)
      },

      getMappedApplications (application_id, is_need_to_show, part) {
        if (is_need_to_show == false) return []

        let applications = this.current_course['applications']

        if (!applications) return []

        let application_title_array = []

        if (Array.isArray(application_id)) {
          // application is array

          application_id.forEach((id) => {
            let index = _.findIndex(applications, { id: id })

            if (index != -1) {
              application_title_array.push(applications[index].title)
            }

            if (application_title_array.length > 1) {
              if (!part['empty_lines']) {
                part.empty_lines = []
              }

              part.empty_lines.push(application_title_array.length - 1)
            }
          })

          return application_title_array
        }

        let index = _.findIndex(applications, { id: application_id })
        if (index == -1) return []

        //return applications[index].title
        application_title_array.push(applications[index].title)

        return application_title_array
      },
    },

    updated () {
        console.log('updated...', this.serieses.length, this.$route)
    },

    computed: {
      ...mapGetters([ 'Serieses' ]),

      serieses() {
        let _serieses = this.Serieses

        return this.prepareSerieses(_serieses)
      },

      is_topic() {
        if (!this.current_course) return false
        if (!this.current_course['course_type']) return false
        if (this.current_course['course_type'] == 'topic') return true

        return false
      },

      has_weeks_columns_4() {
        // debugger
        if (this.weeks_columns_4 == undefined) return false
        if (!this.weeks_columns_4) return false
        if (Array.isArray(this.weeks_columns_4) && this.weeks_columns_4.length == 0) return false

        return true
      },

      getForceVisible () {
        return this.getAttribute(this.current_course, 'application_repeat_visible', false)
      },

      weeks_columns_4() {

        if (!this.current_course) {
          return []
        }
        // debugger
        if (!this.current_course['weeks_columns_4']) {
          return []
        }

        // debugger
        if (Array.isArray(this.current_course['weeks_columns_4'])) {
          return this.current_course['weeks_columns_4']
        }

        return []
      },

      course_prefix() {
        if (!this.current_course) return ''
        if (!this.current_course['id']) return ''
        //if (this.current_course['id'] === undefined) return 0

        // console.log(this.current_course.id)

        return this.current_course.prefix
      },

      course_id() {
        if (this.block_type != 'weekly') return -1

        if (!this.current_course) return 0
        if (!this.current_course['id']) return 0
        //if (this.current_course['id'] === undefined) return 0

        // console.log(this.current_course.id)

        return this.current_course.id
        // return 0
      },

      applications() {
        if (!this.current_course) {
          return []
        }

        return this.current_course.applications
      },

      weeks() {
        console.log('PartList.vue',
          'computed',
          'current watch !!',
          '#821 weeks',
          'this.current_course',
          this.current_course)
        if (!this.current_course) {
          return []
        }

        if (this.current_course['weeks'] && this.current_course['weeks'] != null) {
          return this.current_course.weeks
        }

        return []
      },

      colors: function () {
        if (typeof(this.current_course) == 'string') return
        if (Array.isArray(this.current_course)) return

        if (!this.current_course) {
          return
        }

        //return this.current_course.weeks_setting.colors
        return this.current_course.colors
      },

      play_icons() {
        let icons = {
          over: '',
          i_01: '',
          i_02: '',
        }

        if (!this.assets_path) {
          return icons
        }

        icons.over = this.getCourseImageSrc(this.assets_path, 'page_PLAY_over.png')
        icons.i_01 = this.getCourseImageSrc(this.assets_path, 'page_PLAY01.png')
        icons.i_02 = this.getCourseImageSrc(this.assets_path, 'page_PLAY02.png')

        return icons
      },

      read_icons() {
        let icons = {
          over: '',
          i_01: '',
          i_02: '',
        }

        if (!this.assets_path) {
          return icons
        }

        icons.over = this.getCourseImageSrc(this.assets_path, 'page_READ_over.png')
        icons.i_01 = this.getCourseImageSrc(this.assets_path, 'page_READ01.png')
        icons.i_02 = this.getCourseImageSrc(this.assets_path, 'page_READ02.png')

        return icons
      },

    },

    watch: {
      current_course: function (newValue) {
        console.log('[PartList.vue]',
          '#898 watch currentWeeks',
          'currentWeeks',
          newValue)
      },

      assets_path: function (newValue) {
        // console.log('PartList.vue > watch > asets_path : ', this.assets_path)
      },
      play_icons: function (newValue) {
        // console.log('PartList.vue > watch > play_icons : ', this.play_icons)
      },
      read_icons: function (newValue) {
        // console.log('PartList.vue > watch > read_icons : ', this.read_icons)
      },

      has_weeks_columns_4: function (newValue) {
        // console.log('** PartList.vue > watch > has_weeks_columns_4 : ', this.has_weeks_columns_4)
        // getPartsCount(subject)
        // console.log('** PartList.vue > watch > getPartsCount(subject) : ', this.getPartsCount(this.subject))
      },

      // don't know why can't watch getCurrentCourse
      // so change to set course in CourseIntroduce.vue
      // getCurrentCourse: async function(promise) {
      //     console.log('PartList.vue', 'watch', 'getCurrentCourse : ', value)

      //     let _course = await promise
      //     this.current_course = _course

      //     console.log('PartList.vue', 'watch', 'course', value)

      // },

      // course: function (value) {
      //     console.log('PartList.vue', 'watch', 'course', value)
      // }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/PartList.vue